import React, { useState } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Autocomplete, RenderInputParams } from '@material-ui/lab';
import { TextField, CircularProgress } from '@material-ui/core';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { IAutoCompleteItem } from '../../typings/autoComplete';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        minWidth: '200px',
    },
  })
);

interface DueSelectorProps {
    disabled?: boolean;
    required?: boolean;
    multiple?: boolean;
    // tslint:disable-next-line: no-any
    value?: IAutoCompleteItem | any; // value only available in single select
    error?: boolean;
    onSelection?: (value: IAutoCompleteItem | IAutoCompleteItem[], name: string) => void;
    className?: string;
    helperText?: string;
    name?: string;
    label?: string;
    disablePortal?: boolean;
    variant?: 'standard' | 'outlined' | 'filled';
    size?: 'small' | 'medium';
}

interface DueSelectorState {
    isLoading: boolean;
    error?: boolean;
    options: IAutoCompleteItem[];
}

export enum DueSelectorEnum {
    todayAndEarlier = 0,
    today,
    next3Days,
    next7Days,
    all
}

export const DueSelector: React.FC<DueSelectorProps> = props => {

    const classes = useStyles();

    const [state] = useState<DueSelectorState>({
        isLoading: false,
        error: props.error,
        options: [
            {
                label: 'Today and earlier',
                value:  DueSelectorEnum[DueSelectorEnum.todayAndEarlier]
            },
            {
                label: 'Today',
                value:  DueSelectorEnum[DueSelectorEnum.today]
            },
            {
                label: 'Next 3 Days',
                value:  DueSelectorEnum[DueSelectorEnum.next3Days]
            },
            {
                label: 'Next 7 Days',
                value:  DueSelectorEnum[DueSelectorEnum.next7Days]
            },
            {
                label: 'All',
                value:  DueSelectorEnum[DueSelectorEnum.all]
            },
        ],
    });

    // tslint:disable-next-line: no-any
    const handleChange = (event: React.ChangeEvent<{}>, value: any) => {
        if (props.onSelection) {

            const tempValue = value && value.hasOwnProperty('value') ? value : { label: '', value: ''};

            props.onSelection(tempValue, props.name ? props.name : 'followUpDue');
        }
    };

    const getInputProps = (params: RenderInputParams, isLoading?: boolean) => {
        return  ({   
            ...params.InputProps,
            endAdornment: (
                <React.Fragment>
                  {isLoading ? <CircularProgress color="primary" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),     
         });
    };

    return (
        <div className={`${classes.root} ${props.className}`}>
            { props.multiple ? 
                (
                    <Autocomplete
                        value={props.value}
                        multiple={true}
                        // loading={state.isLoading}
                        disabled={props.disabled}
                        onChange={handleChange}
                        options={state.options}
                        disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                        // tslint:disable-next-line: jsx-no-lambda
                        getOptionLabel={(option: IAutoCompleteItem) => option.label}      
                        // getOptionSelected={(option, value) => value.value === option.value}                    
                        // tslint:disable-next-line: jsx-no-lambda
                        size={props.size ? props.size : 'medium'}
                        ChipProps={{
                            size: props.size ? props.size : 'medium'
                        }}
                        renderInput={params => (
                            <TextField 
                                {...params} 
                                label={props.label}
                                variant={props.variant ? props.variant : 'standard'} 
                                fullWidth={true} 
                                margin="none" 
                                required={props.required}
                                InputProps={getInputProps(params, false)}
                                error={state.error}      
                                helperText={props.helperText}      
                                size={props.size ? props.size : 'medium'}                
                            />
                        )}
                        // tslint:disable-next-line: jsx-no-lambda
                        renderOption={(option, { inputValue }) => {
                            const matches = match(option.label, inputValue);
                            const parts = parse(option.label, matches);
                    
                            return (
                                <div>
                                    {parts.map((part, index) => (
                                        <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                            {part.text}
                                        </span>
                                    ))}
                                </div>
                            );
                        }}
                    />
                )
                :
                (
                    <Autocomplete
                        value={props.value}
                        loading={state.isLoading}
                        disabled={props.disabled}
                        onChange={handleChange}
                        options={state.options}
                        disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                        // tslint:disable-next-line: jsx-no-lambda
                        getOptionLabel={(option: IAutoCompleteItem) => option.label} 
                        getOptionSelected={(option, value) => value.value === option.value}   
                        size={props.size ? props.size : 'medium'}           
                        // tslint:disable-next-line: jsx-no-lambda
                        renderInput={params => (
                            <TextField 
                                {...params} 
                                label={props.label}
                                variant={props.variant ? props.variant : 'standard'} 
                                fullWidth={true} 
                                margin="none" 
                                required={props.required}
                                InputProps={getInputProps(params, state.isLoading)}
                                error={state.error} 
                                size={props.size ? props.size : 'medium'}                           
                            />
                        )}
                        // tslint:disable-next-line: jsx-no-lambda
                        renderOption={(option, { inputValue }) => {
                            const matches = match(option.label, inputValue);
                            const parts = parse(option.label, matches);
                    
                            return (
                                <div>
                                {parts.map((part, index) => (
                                    <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                    {part.text}
                                    </span>
                                ))}
                                </div>
                            );
                        }}
                    />
                )
            }
        </div>
    );
};
